<div class="share-button-container">
  <button *ngIf="!useMobileButton" class="btn btn-secondary" (click)="toggleMenu($event)" [style.color]="themeColor" [style.border-color]="themeColor">Share</button>
  <i *ngIf="useMobileButton" class="icon icon-share" (click)="toggleMenu($event)"></i>
  <div *ngIf="!modal && showMenu" class="share-menu" ClickOutside (clickOutside)="toggleMenu()" [hidden]="false">
    <share-menu [job]="job" [modal]="modal" [openUp]="openUp"></share-menu>
  </div>
</div>

<div *ngIf="modal && showMenu" (click)="toggleMenu($event)" class="overlay"></div>
<div *ngIf="modal && showMenu" (click)="$event.stopPropagation()" id="share-modal">
  <div class="share-modal-header">Share through</div>
  <share-menu [job]="job" [modal]="modal"></share-menu>
</div>
